import { filtersToData } from './filtersToData.js';

/*
    Our filters are an array of objects.
    Our graphQL call requires this array to be reformatted as a string:
        '[
            {
                id: 1
                terms: [2]
            },
            {
                id: 2
                terms: [3,4]
            }
        ]'
    That's what this function does!
*/
export function filtersToString(reactiveFilters) {

    const filters = JSON.parse(JSON.stringify(reactiveFilters));

    const filterData = filtersToData(filters);

    const JSONstring = JSON.stringify(filterData);

    const filtersString = JSONstring.replace(/"/g, '');

    return filtersString;

}
